import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-gray-50 dark:bg-[#0F1F1D] transition-colors duration-300 flex flex-col" data-id="element-5639">
      <Navbar scrolled={false} data-id="element-5640" />
      <main className="flex-1 flex items-center justify-center px-4 py-24" data-id="element-5641">
        <div className="text-center max-w-md" data-id="element-5642">
          <div className="w-16 h-16 bg-gray-100 dark:bg-[#1A3330] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-5643">
            <SearchIcon className="h-8 w-8 text-gray-400 dark:text-[#7A8F8A]" data-id="element-5644" />
          </div>
          <h1 className="text-6xl font-bold text-gray-200 dark:text-[#1A3330] mb-4" data-id="element-5645">
            404
          </h1>
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-5646">
            Page Not Found
          </h2>
          <p className="text-gray-500 dark:text-[#7A8F8A] mb-8" data-id="element-5647">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <button onClick={() => navigate('/')} className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-white rounded-lg font-medium hover:shadow-lg transition-all" data-id="element-5648">
            Go Home
          </button>
        </div>
      </main>
      <Footer data-id="element-5649" />
    </div>;
};